import MyFavoriteApi from '@/api/my/favorite';
import {SectionHeader} from '@/components/main/common';
import {useEffect} from 'react';
import '/public/static/css/module/cBox.scss';
import useMyStore from '@/stores/my';
import MyBroadcastLayout from '../common/MyBroadcastLayout';
import {ErrorBoundary} from '@/components/common';
import {
  BroadcastLayout,
  BroadcastType,
} from '@/components/main/common/Broadcast';
import {BROADCAST_TYPES} from '@/constants';
import {RECOMMEND_CONTEXT_MENU} from '@/constants/my/contextMenu';
import throwToast from '@/utils/ui/toast';

/**
 * 즐겨찾기 페이지 라이브 방송 목록 컴포넌트
 */
const RecommendStreamer = () => {
  const {setRecommendBroadcast, recommendBroadcast} = useMyStore();

  useEffect(() => {
    const getRecommendStreamers = async () => {
      try {
        const recommendStreamers = await MyFavoriteApi.getRecommendStreamers();

        setRecommendBroadcast(recommendStreamers);
      } catch (error) {
        return [];
      }
    };

    getRecommendStreamers();
  }, []);

  const handleContextMenuClick =
    (broadcastUserId, broadcastId, broadcastLogic) => async (event, type) => {
      if (type !== 'not-recommend') {
        return;
      }

      const recommendedStreamerIds = recommendBroadcast.map(
        (broadcast) => broadcast.userId,
      );

      try {
        const {filterId, addInfo} = await MyFavoriteApi.rejectRecommend({
          streamerId: broadcastUserId,
          broadcastId: broadcastId,
          logic: broadcastLogic,
          recommendedStreamerIds,
        });
        throwToast('해당 방송을 더 이상 추천하지 않습니다.');
        const filteredBroadcasts = recommendBroadcast.filter(
          (broadcast) => broadcast.userId !== filterId,
        );
        const newAddInfo =
          addInfo && Array.isArray(addInfo) && addInfo.length > 0
            ? addInfo
            : [];
        setRecommendBroadcast([...filteredBroadcasts, ...newAddInfo]);
      } catch (error) {
        throwToast('에러가 발생하였습니다.');
      }
    };

  return (
    recommendBroadcast?.length > 0 && (
      <>
        <SectionHeader title='추천 스트리머' />
        <MyBroadcastLayout type='swiper'>
          {recommendBroadcast?.map((broadcast) => (
            <ErrorBoundary key={broadcast.broadNo}>
              <BroadcastLayout
                broadcastType={BROADCAST_TYPES.LIVE}
                thumbnailUrl={broadcast.broadImg}
                viewCount={broadcast.totalViewCnt}
                startDateTime={broadcast.broadStart}
                userNickname={broadcast.userNick}
                title={broadcast.broadTitle}
                broadcastId={broadcast.broadNo}
                userId={broadcast.userId}
                categoryTags={broadcast.categoryTags}
                categoryNo={broadcast.broadCateNo}
                hashTags={broadcast.hashTags}
                autoHashTags={broadcast.autoHashtags}
                accessibleAge={Number(broadcast.grade)}
                allowsAdult={Number(broadcast.grade) === 19}
                isFan={broadcast.isFanclub}
                isSubscribe={broadcast.isSubscribe}
                canResend={broadcast.isVisitBroad}
                hasPassword={broadcast.isPassword}
                hasDrops={broadcast.isDrops}
                contextMenu={{
                  menuList: RECOMMEND_CONTEXT_MENU,
                }}
                liveType={broadcast.broadType}
                handleMenuClicked={handleContextMenuClick(
                  broadcast.userId,
                  broadcast.broadNo,
                  broadcast.logic,
                )}
                subscriptionOnly={broadcast.subscriptionOnly}>
                <BroadcastType.Live />
              </BroadcastLayout>
            </ErrorBoundary>
          ))}
        </MyBroadcastLayout>
      </>
    )
  );
};

export default RecommendStreamer;
